import { __read, __spreadArray } from "tslib";
import React, { memo } from 'react';
import stringify from 'fast-safe-stringify';
import { ConditionalField } from '../fields/ConditionalField';
import { RadioField } from '../fields/RadioField';
import { CheckboxField } from '../fields/CheckboxField';
import { DatePickerField } from '../fields/DatePickerField';
import { SelectField } from '../fields/SelectField';
import { SectionField } from '../fields/SectionField';
import { ArrayField } from '../fields/ArrayField';
import { InputField } from '../fields/InputField';
import { CustomField } from '../fields/CustomField';
import { ReadOnlyField } from '../fields/ReadOnlyField';
import { TextareaField } from '../fields/TextareaField';
import { ButtonField } from '../fields/ButtonField';
import { NutsSelectorField } from '../fields/NutsSelectorField';
import { CPVField } from '../fields/CPVField';
import { InputDropdownField } from '../fields/InputDropdownField';
import { AlertField } from '../fields/AlertField';
export var SchemaElement = memo(function (_a) {
    var field = _a.field, fieldName = _a.fieldName, pop = _a.pop, push = _a.push;
    var conditionalRender = field.conditionalRender;
    var componentToRender;
    switch (field.type) {
        case 'array':
            componentToRender = (React.createElement(ArrayField, { field: field, name: fieldName, pop: pop, push: push, SchemaElement: SchemaElement }));
            break;
        case 'button':
            componentToRender = (React.createElement(ButtonField, { field: field, name: fieldName }));
            break;
        case 'checkbox':
            componentToRender = (React.createElement(CheckboxField, { field: field, name: fieldName }));
            break;
        case 'cpv-selector':
            componentToRender = React.createElement(CPVField, { field: field, name: fieldName });
            break;
        case 'custom':
            componentToRender = (React.createElement(CustomField, { field: field, name: fieldName }));
            break;
        case 'date-time-picker':
            componentToRender = (React.createElement(DatePickerField, { field: field, name: fieldName }));
            break;
        case 'input-dropdown':
            componentToRender = (React.createElement(InputDropdownField, { field: field, name: fieldName }));
            break;
        case 'nuts-selector':
            componentToRender = (React.createElement(NutsSelectorField, { field: field, name: fieldName }));
            break;
        case 'radio':
            componentToRender = (React.createElement(RadioField, { field: field, name: fieldName }));
            break;
        case 'readOnly':
            componentToRender = (React.createElement(ReadOnlyField, { field: field, name: fieldName }));
            break;
        case 'section':
            componentToRender = (React.createElement(SectionField, { field: field, name: fieldName, pop: pop, push: push, SchemaElement: SchemaElement }));
            break;
        case 'select':
            componentToRender = (React.createElement(SelectField, { field: field, name: fieldName }));
            break;
        case 'textarea':
            componentToRender = (React.createElement(TextareaField, { field: field, name: fieldName }));
            break;
        case 'alert':
            componentToRender = (React.createElement(AlertField, { field: field, name: fieldName }));
            break;
        default:
            componentToRender = (React.createElement(InputField, { field: field, name: fieldName }));
    }
    return conditionalRender ? (React.createElement(ConditionalField, { conditionalRulesChainOption: conditionalRender.conditionalRulesChainOption, conditionalRules: conditionalRender.conditionalFields
            ? __spreadArray([], __read(conditionalRender.conditionalFields), false) : [], fieldName: fieldName, associatedVisibilityBasedOnOtherFieldValues: conditionalRender.associatedVisibilityBasedOnOtherFieldValues }, componentToRender)) : (componentToRender);
}, function (prevProps, nextProps) {
    try {
        return stringify(prevProps) === stringify(nextProps);
    }
    catch (e) {
        console.warn("SchemaElement: ".concat(e));
        return false;
    }
});
SchemaElement.displayName = 'SchemaElement';
